import { IPersonalDetails } from 'API/personalDetails';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DisabilityAccordion } from './DisabilityAccordion';
import { FamilyStatusAccordion } from './FamilyStatusAccordion';
import { GeneralAccordion } from './GeneralAccordion';
import { useDictionary } from 'Hooks';

interface IAccordionsPersonalDetails {
  personalDetails: IPersonalDetails | null;
}

export const AccordionsPersonalDetails = ({
  personalDetails,
}: IAccordionsPersonalDetails) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalDetails);

  return (
    <>
      <GeneralAccordion
        title={dictionary.userGeneralInformation.title}
        userInfo={{
          fullName: personalDetails?.firstName
            ? personalDetails?.firstName + ' ' + personalDetails?.lastName
            : '',
          id: personalDetails?.israeliId || '',
          caseNumber: personalDetails?.caseNumber || '',
          familyStatus: personalDetails?.familyStatus || '',
        }}
        isRecognized={Boolean(
          personalDetails?.caseNumber &&
            parseInt(personalDetails.disabilityPercent) >= 10
        )}
        haveFamilyMembers={
          personalDetails?.familyMembers
            ? personalDetails?.familyMembers?.length > 0
            : false
        }
      />
      <GeneralAccordion
        title={dictionary.contactInformation.title}
        userContact={{
          phones: personalDetails?.phones || [],
        }}
      />
      <FamilyStatusAccordion
        title={dictionary.familyStatus.title}
        userFamily={personalDetails?.familyMembers || []}
        status={personalDetails?.familyStatus || ''}
      />

      <GeneralAccordion
        title={dictionary.addressInformation.title}
        userAddress={personalDetails?.addresses || []}
      />
      <GeneralAccordion
        title={dictionary.bankInformation.title}
        userBank={{
          bankName: personalDetails?.bankDetails?.bankName || '',
          branchCode: personalDetails?.bankDetails?.branchCode || '',
          branchName: personalDetails?.bankDetails?.branchName || '',
          accountNum: personalDetails?.bankDetails?.accountNum || '',
        }}
      />
      <DisabilityAccordion
        title={dictionary.disabilityInformation.title}
        userDisability={{
          disabilityPercent: personalDetails?.disabilityPercent || '',
          disabilitySections: personalDetails?.disabilitySections || [],
          disabilityStatus: personalDetails?.disabilityStatus || '',
        }}
      />
    </>
  );
};
